import { createTheme } from '@mui/material/styles';

const fontFamily = [
  'Inter',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(',');

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1B4F72',
      light: '#3D7BB0',
      dark: '#123650',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#0E9384',
    },
    background: {
      default: '#F5F7FA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1A2330',
      secondary: '#5B6472',
    },
    divider: '#E2E7EE',
    avatar: {
      placeholder: '#C4CBD4',
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily,
    h1: { fontFamily, fontWeight: 700 },
    h2: { fontFamily, fontWeight: 700 },
    h3: { fontFamily, fontWeight: 700 },
    h4: { fontFamily, fontWeight: 700 },
    h5: { fontFamily, fontWeight: 600 },
    h6: { fontFamily, fontWeight: 600 },
    button: { fontFamily, fontWeight: 600, textTransform: 'none' },
    menu: { fontFamily, fontWeight: 700 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'h1, h2, h3, h4, h5, h6, label, p': {
          fontFamily,
        },
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: '#C1C9D2 transparent',
        },
        '*::-webkit-scrollbar': {
          width: 8,
          height: 8,
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#C1C9D2',
          borderRadius: 8,
        },
        '*::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#A6B0BC',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(16, 24, 40, 0.08)',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
          paddingLeft: 18,
          paddingRight: 18,
        },
        startIcon: {
          marginRight: 3,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        elevation1: {
          boxShadow: '0 1px 2px rgba(16, 24, 40, 0.06), 0 1px 3px rgba(16, 24, 40, 0.05)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 2px rgba(16, 24, 40, 0.06), 0 2px 8px rgba(16, 24, 40, 0.06)',
          border: '1px solid #E2E7EE',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme;
